import api from "../api/axios";

export const exportAttendanceData = async (params) => {
  try {
    const response = await api.get(`api/attendance/export/record`, {
      params,
      responseType: "blob",
    });

    const fileType = params.fileType || "xlsx";
    const filename = fileType === "pdf" ? "attendance.pdf" : "attendance.xlsx";

    const blob = new Blob([response.data], {
      type:
        fileType === "pdf"
          ? "application/pdf"
          : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error("Error exporting Employee attendance data:", error);
    throw error;
  }
};
